'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var List_module = require('../styles/List.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Ordered list element.
 *
 * @component
 * @example
 * ```jsx
 * <OrderedList>...</OrderedList>
 * ```
 */
const OrderedList = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(List_module.default);
    const classNames = cx(className, 'ordered');
    return (React__namespace.createElement("ol", { ref: ref, className: classNames, ...restProps }, children));
});
OrderedList.displayName = 'OrderedList';

exports.OrderedList = OrderedList;
//# sourceMappingURL=OrderedList.js.map
